import { render, staticRenderFns } from "./CimavillaInfo.vue?vue&type=template&id=0a7409cc&scoped=true&"
import script from "./CimavillaInfo.vue?vue&type=script&lang=js&"
export * from "./CimavillaInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7409cc",
  null
  
)

export default component.exports